module.exports = __webpack_public_path__ + "img/weight-juice.07e6b448.png";